import React, { useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import planApi from '../../services/planApi';
import MainLayout from '../layout/MainLayout';
import Availability from '../plan/Availability';
import '../../styles/mentee-dashboard.scss';
import '../plan/plan.scss';

const MentorSessions: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [relId, setRelId] = useState<number | null>(null);
  const [consentOk, setConsentOk] = useState(false);

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const load = async () => {
    try {
      setLoading(true);
      const dResp = await apiService.mentor.dashboard();
      const mentees = dResp.data?.data?.active_mentees || [];
      const id = mentees[0]?.id || null;
      setRelId(id);
      if (id) {
        const p = await planApi.getPlan(id);
        setConsentOk(!!(p as any)?.locks?.fodaEnabled);
      }
    } catch {
      setRelId(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="mentee-dashboard sessions-view">
        <div className="sv-eyebrow">Mentor</div>
        <h1 className="sv-title">Mis <em>Sesiones</em></h1>
        <p className="sv-lead">Agenda, propón y da seguimiento a las sesiones con tu mentee.</p>

        <div className="sessions-page">
          {loading ? (
            <p className="dash-empty">Cargando sesiones…</p>
          ) : !relId ? (
            <p className="dash-empty">Aún no tienes un mentee asignado. Cuando se asigne tu dupla, podrás agendar sesiones aquí.</p>
          ) : (
            <Availability relId={relId} role="mentor" consentOk={consentOk} onChanged={load} />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default MentorSessions;
